import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/HomePage.vue'
import AboutUs from '@/components/nosotros/AboutusPage'
import Servicios from '@/components/servicios/ServiciosmainPage'
import Destinos from '@/components/destinos/destinos'
import Clientes from '@/components/clientes/clientes'
import Contacto from '@/components/contacto/contacto'
import Infraestructura from '@/components/infraestructura/infraestructura'





Vue.use(Router)

export default new Router({
  routes: [
   {path: '/', component: Home},
   {path: '/nosotros', component: AboutUs},
   {path: '/servicios', component: Servicios},
   {path: '/destinos', component: Destinos},
   {path: '/clientes', component: Clientes},
   {path: '/contacto', component: Contacto},
   {path: '/infraestructura', component: Infraestructura}
   
   
   

  ],
  mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js